import get from 'lodash/get';
import {getCmaTemplateName} from 'lib/ReportUtil';
import dateFormat from 'dateformat';

export function makeNzTitlesSection(s, nzTitles) {
  const template = getCmaTemplateName(s.key, 1);
  const currentDate = dateFormat(new Date(), 'dddd dS mmmm yyyy');

  return {
    name: s.key,
    template,
    title: get(s, 'sectionData.title', 'Title Details Report'),
    data: {
      sectionTitle: get(s, 'sectionData.title', 'Title Details Report'),
      updatedText: `Up to date as of ${currentDate}`,
      disclaimersTitle: '',
      disclaimersText: '',
    },
    dataSource: get(nzTitles, 'titles', []),
  };
}